import { LIVE_HELP_TOPIC } from '@/queries/constants'
import type { UserContextType } from '@/client/context/user'

import { hasUserRole } from '../user'

export default function userHasSessionPageAccess(
  session: {
    seriesId: number | null
    topicName: string
    isUserTutor: boolean
    isDropIn?: boolean
    userMatchesSessionResearchGroup?: boolean
  },
  user: UserContextType
): {
  hasAccess: boolean
  restrictionType: null | 'series' | typeof LIVE_HELP_TOPIC
} {
  const {
    isUserTutor,
    seriesId,
    topicName,
    isDropIn = false,
    userMatchesSessionResearchGroup = false,
  } = session
  const isSeriesSession = seriesId != null
  const isLiveHelpSession = topicName === LIVE_HELP_TOPIC

  const canAccessRestrictedSessionPage = hasUserRole(user, 'admin:tutor_operations:lead')

  if (!userMatchesSessionResearchGroup) {
    return { hasAccess: canAccessRestrictedSessionPage, restrictionType: null }
  }

  if (isSeriesSession) {
    return {
      hasAccess: canAccessRestrictedSessionPage || isDropIn,
      restrictionType: 'series',
    }
  }

  if (isLiveHelpSession) {
    return {
      hasAccess: isUserTutor || canAccessRestrictedSessionPage,
      restrictionType: LIVE_HELP_TOPIC,
    }
  }

  return { hasAccess: true, restrictionType: null }
}
